import { Button, styled } from '@mui/material';
import { OptionButtonProps } from './types';
import { RookeryBoldFont } from 'v3/styles/common';

export const StyledOptionButton = styled(Button)<OptionButtonProps>(({ selected, theme }) => ({
  font: `700 1rem ${RookeryBoldFont}`,
  textTransform: 'unset',
  color: theme.palette.common.white,
  minWidth: '7.625rem',
  height: '2.25rem',
  borderRadius: '0.5rem',
  cursor: 'pointer',
  border: selected ? '2px solid transparent' : `1px solid ${theme.palette.secondary.main}`,
  backgroundImage: selected ? `${theme.palette.gradient[700]}, ${theme.palette.gradient[100]}` : 'none',
  backgroundOrigin: 'border-box',
  backgroundClip: 'padding-box, border-box',
  width: '100%'
}));
